/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SkillAreaModel } from '../../models/skill-area-model';

export interface GetSkillAreas$Params {
  patientID?: number;
  onlyActive?: boolean;
}

export function GetSkillAreas(http: HttpClient, rootUrl: string, params?: GetSkillAreas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SkillAreaModel>>> {
  const rb = new RequestBuilder(rootUrl, GetSkillAreas.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SkillAreaModel>>;
    })
  );
}

GetSkillAreas.PATH = '/api/Supervisor/GetSkillAreas';
